"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldContainer = exports.RequiredSpan = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
exports.RequiredSpan = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 2px;\n  color: red;\n"], ["\n  margin-right: 2px;\n  color: red;\n"])));
var FormFieldContainer = (function (_super) {
    __extends(FormFieldContainer, _super);
    function FormFieldContainer(props) {
        return _super.call(this, props) || this;
    }
    FormFieldContainer.prototype.render = function () {
        var _a = this.props, label = _a.label, children = _a.children, fieldState = _a.fieldState, required = _a.required, noLabel = _a.noLabel, tooltip = _a.tooltip;
        return (React.createElement(React.Fragment, null,
            !noLabel ? (React.createElement("label", { className: 'field-label', title: tooltip },
                required ? React.createElement(exports.RequiredSpan, null, "*") : null,
                label)) : null,
            React.createElement("div", { className: 'gsi-form-field-container' },
                React.createElement("div", { className: 'gsi-input-and-error-container' },
                    children,
                    !!fieldState && fieldState.hasError ? (React.createElement("span", { className: 'gsi-error-span' }, fieldState.error)) : null))));
    };
    return FormFieldContainer;
}(React.Component));
exports.FormFieldContainer = FormFieldContainer;
var templateObject_1;
